import { render, staticRenderFns } from "./MagnumPage.vue?vue&type=template&id=3ddaeb7a"
import script from "./MagnumPage.js?vue&type=script&lang=js&external"
export * from "./MagnumPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports